import { Loader } from '../Loader';

import style from './CenteredLoader.module.css';

export type CenteredLoaderProps = {
  label?: string;
};

export const CenteredLoader = ({ label }: CenteredLoaderProps) => {
  return (
    <div className={style.loader_container}>
      <Loader />
      {label ? <span className={style.loader_label}>{label}</span> : null}
    </div>
  );
};
